import React from "react";
import { Container, Row, Col } from "reactstrap";
import ProductsList from "../components/UI/ProductsList";
import products from "../assets/data/products";
import Helmet from "../components/Helmet/Helmet";

import "../styles/filter-item.css";

const Pizza = () => {
  const filteredProducts = products.filter((item) => item.category === "pizza");

  return (
    <Helmet title="Pizza">
      <section className="filtered__items">
        <Container>
          <Row>
            <Col lg="12">
              <h2 className="filtered__items-title text-center mt-5 mb-5">Pizza</h2>
            </Col>
            <ProductsList data={filteredProducts} />
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default Pizza;
